/* S1 Team Grid: pill toggle between the two title-keyword groups, plus the
   SPA's locale-aware alphabetical sort on the cleaned card titles (Liquid's
   byte-wise sort can't ignore this collection's inconsistent title
   whitespace, so the cards are ordered here instead). */

class S1TeamGrid extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-tg-grid]').forEach((grid) => {
      [...grid.children]
        .sort((a, b) => (a.dataset.tgName || '').localeCompare(b.dataset.tgName || ''))
        .forEach((card) => grid.appendChild(card));
    });

    if (this._bound) return;
    this._bound = true;
    this.querySelectorAll('[data-tg-gender]').forEach((btn) => {
      btn.addEventListener('click', () => {
        this.dataset.gender = btn.dataset.tgGender;
        this.querySelectorAll('[data-tg-gender]').forEach((b) => {
          b.classList.toggle('is-active', b === btn);
        });
      });
    });
  }
}

if (!customElements.get('s1-team-grid')) {
  customElements.define('s1-team-grid', S1TeamGrid);
}
